<template>
  <a-config-provider :locale="zhCN" :theme="antdTheme">
    <router-view />
  </a-config-provider>
</template>

<script setup>
import { computed } from 'vue';
import { theme as antdTokens } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { isDark } from '@/stores/theme';
import './theme.css';

// AntD 组件主题根：darkAlgorithm 经 MF singleton（ant-design-vue 共享实例）穿透所有插件 remote。
// 紧凑化（2026-10-16）：用户反馈弹窗/抽屉/表单间距过大。antdv 4.2 的 Modal/Drawer
// 不支持组件级 token（样式内部直接引用全局 alias token 派生），故在此全局下调
// padding/margin 档位一档，MF 穿透所有插件。依据（es/ 源码核实）：
//   Drawer header = padding×2 / Drawer body = paddingLG
//   Modal content = paddingMD × paddingContentHorizontalLG / 距屏底 = paddingLG
//   Modal footer 上方 = marginSM / Form item 间距 = marginLG
//   Table 单元格 = padding ×2 / Card body = paddingLG / Card 头高 = 24+padding×2
// 按钮高度走 controlHeight。
//
// 全局紧凑开关（2026-10-18）不走 compactAlgorithm：default 派生签名 (token) 忽略
// 上游 mapToken（dark 派生 (token, mapToken) 才消费），[compact, default] 链式组合
// 下 compact 的 controlHeight-4 会被 default 全量重算覆盖（浅色完全不生效，实测；
// 暗色因 dark 消费 mapToken 而「偶然」生效——两主题行为分裂不可接受）。
// 控件密度改由 theme.css 的 html[data-compact='1'] 规则直接定高，两主题统一。
const compactToken = {
  padding: 12,        // 16→12：抽屉头/卡片头/表格单元格
  paddingMD: 16,      // 20→16：弹窗内容上下
  paddingLG: 16,      // 24→16：抽屉正文/弹窗左右/弹窗距屏底
  paddingXL: 24,      // 32→24
  paddingContentHorizontalLG: 20, // 24→20：弹窗内容左右
  margin: 12,         // 16→12
  marginSM: 8,        // 12→8：弹窗按钮区上方
  marginLG: 16,       // 24→16：表单项间距（弹窗内表单疏密的主因）
  marginXL: 24,       // 32→24
};
const antdTheme = computed(() => ({
  algorithm: isDark.value ? antdTokens.darkAlgorithm : antdTokens.defaultAlgorithm,
  token: compactToken,
}));
</script>
